import {
    useQuery,
    useMutation,
    mutateAsync,
    useQueryClient,
  } from 'react-query';

  import { overlayStates, selectApiPath } from './helper-methods/constants';
  import {
    ifscCheckAPI,
    getPreSingedUrlApi,
    postSaveDocumentsApi,
    postUserDetails,
    getSampleJson,
    patchNameMismatchApi,
    saveDigilockerResponse,
    getDocumentDownloadApi,
    intiateDigilocker,
    intiateEsign,
    saveEsignResponse,
    postSaveKycVideo,
    getInitialVerifyInfo,
  } from './http-calls';
  
  export const useSampleJson = () => {
    return useQuery('sampleJson', () => getSampleJson(), { enabled: false });
  };
  
  export const useInitialVerifyInfo = (data) => {
    return useQuery('initialVerifyInfo', () => getInitialVerifyInfo(data), {});
  };
  
  export const useIFSCCheck = (value) => {
    const dataToSend = {
      ifsc: value,
    };
    return useQuery('ifscCheck', () => ifscCheckAPI(dataToSend), {
      enabled: false,
    });
  };
  
  export const usePostAsyncUserDetails = ({ data, subSection }) => {
    const { customerId, payload } = data;
    console.log('data-to-send', payload);
    const path = selectApiPath[subSection];
    return useQuery(
      path,
      () =>
        postUserDetails({
          customerId,
          payload,
          path,
        }),
      {
        enabled: false,
      }
    );
  };
  
  export const usePostUserDetails = ({ data, subSection }) => {
    const { customerId, payload } = data;
    console.log('data-to-send', payload);
    const path = selectApiPath[subSection];
    return useQuery(
      path,
      () =>
        postUserDetails({
          customerId,
          payload,
          path,
        }),
      {
        enabled: false,
      }
    );
  };
  
  export const usePostNameMismatch = ({ data }) => {
    const { customerId, payload } = data;
    const path = 'nameMismatch';
    return useQuery(
      path,
      () =>
        patchNameMismatchApi({
          customerId,
          payload: payload,
        }),
      {
        enabled: false,
      }
    );
  };
  
  export const useCustomQuery = ({ section }) => {
    return useQuery(section, () => {}, {
      enabled: false,
    });
  };
  
  export const useSaveDigioResponse = (data) => {
    const queryClient = useQueryClient();
    return useMutation(saveDigilockerResponse, {
      onSuccess: async (data) => {
        // return data ;
        // const message='success'
      },
      onError: (err) => {},
  
      onSettled: () => {
        queryClient.invalidateQueries('created');
      },
    });
  };
  
  export const useDigilockerInitiation = (data) => {
    const queryClient = useQueryClient();
    return useMutation(intiateDigilocker, {
      onSuccess: async (data1) => {
        // return data ;
        // const message='success'
      },
      onError: (err) => {},
  
      onSettled: () => {
        queryClient.invalidateQueries('created');
      },
    });
  };
  
  export const useEsignInitiation = (data) => {
    const queryClient = useQueryClient();
    return useMutation(intiateEsign, {
      onSuccess: async (data1) => {
        // return data ;
        // const message='success'
      },
      onError: (err) => {},
  
      onSettled: () => {
        queryClient.invalidateQueries('created');
      },
    });
  };
  
  export const useSaveEsignResponse = (data) => {
    const queryClient = useQueryClient();
    return useMutation(saveEsignResponse, {
      onSuccess: async (data) => {
        // return data ;
        // const message='success'
      },
      onError: (err) => {},
  
      onSettled: () => {
        queryClient.invalidateQueries('created');
      },
    });
  };
  
  export const useSaveDocuments = (data) => {
    const queryClient = useQueryClient();
    return useMutation(postSaveDocumentsApi, {
      onSuccess: (data) => {
        const message = 'success';
      },
      onError: (err) => {},
      onSettled: () => {
        queryClient.invalidateQueries('created');
      },
    });
  };
  
  export const useFetchPreSingedUrl = (data, key = 'pre_singed_url') => {
    return useQuery(key, () => getPreSingedUrlApi(data), {
      enabled: false,
    });
  };
  
  export const useGetDocumentDownload = (data) => {
    const { section, payload } = data;
    return useQuery(
      `user_docs_${section}`,
      () => getDocumentDownloadApi(payload),
      {
        enabled: false,
      }
    );
  };
  
  export const usePolling = ({
    queryKey,
    queryFn, // should return value from overlayStates
    currentState, // state to start polling (should contain value from overlayStates)
    pollingStopSideEffect,
    pollingInterval = 4000,
  }) => {
    return useQuery(queryKey, queryFn, {
      refetchInterval: (data) => {
        const status = data?.status;
        // Condition to stop polling
        if (!currentState || currentState === overlayStates.EXTERNAL_API_ERROR)
          return undefined;
        if (status && status !== currentState) {
          if (pollingStopSideEffect) {
            console.log('changing-overlay-state');
            pollingStopSideEffect(data);
          }
          return status === overlayStates.POLLING ? pollingInterval : undefined;
        }
  
        // Condition to start polling
        return currentState === overlayStates.POLLING
          ? pollingInterval
          : undefined;
      },
    });
  };
  
  export const usePostSaveKycVideo = ({ data, subSection }) => {
    console.log('usePostSaveKycVideo:', { data });
    const path = selectApiPath[subSection];
    console.log('usePostSaveKycVideo:', { path });
  
    return useQuery(path, () => postSaveKycVideo({ ...data, path }), {
      enabled: false,
    });
  };
  